import {Component, OnDestroy, OnInit} from '@angular/core';
import { AuthService } from '../security/auth.service';
import { CognitoUserService } from '../services/cognito-user.service';
import { ActivatedRoute, Router } from '@angular/router';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { PasswordStrengthValidator } from '../helper/confirmed.validator';
import {
  RESET_PASSWORD_FIELDS_MISSING,
  RESET_PASSWORDS_NOT_MATCHING,
  PASSWORD_STRENGTH_VALIDATION_MESSAGE,
  PASSWORDS_MUST_MATCH,
  VERIFICATION_PATH, LOGIN_PATH, REGISTRATION_ACTIVATED_STATUS,LOGO_TEXT
} from '../common/Constants';
import { MessageHandlerService } from '../services/message-handler.service';
import {UserService} from "../services/user.service";
import {Subscription} from "rxjs";

@Component({
  selector: 'app-complete-new-password',
  templateUrl: './complete-new-password.component.html',
  styleUrls: ['./complete-new-password.component.scss'],
})
export class CompleteNewPasswordComponent implements OnInit, OnDestroy {
  completeNewPasswordForm: FormGroup; //= new FormGroup({});
  logoText = LOGO_TEXT;
  PASSWORD_STRENGTH_VALIDATION_MESSAGE = PASSWORD_STRENGTH_VALIDATION_MESSAGE;
  PASSWORDS_MUST_MATCH = PASSWORDS_MUST_MATCH;
  subscription: Subscription;
  constructor(
    private readonly router: Router,
    private readonly authService: AuthService,
    private readonly cognitoUserService: CognitoUserService,
    private readonly messageHandlerService: MessageHandlerService,
    private readonly userService: UserService,
    private readonly fb: FormBuilder,
    private readonly route: ActivatedRoute,
  ) {
    this.completeNewPasswordForm = this.fb.group({
      oldPassword: [null, Validators.compose([Validators.required, Validators.minLength(8), PasswordStrengthValidator])],
      newPassword: [null, Validators.compose([Validators.required, Validators.minLength(8), PasswordStrengthValidator])],
      confirmNewPassword: [null, [Validators.required]],
    });
  }

  ngOnInit(): void {
    this.autoPopulateEmailAndPassword();
  }

  ngOnDestroy(): void {
    if(this.subscription){
      this.subscription.unsubscribe();
    }
  }

  autoPopulateEmailAndPassword() {
    if(!this.cognitoUserService.cognitoUser) {
      this.router.navigate([LOGIN_PATH]);
    }

    this.route.queryParams.subscribe((params) => {
      const password = params['password'];
      if (password) {
        this.completeNewPasswordForm.patchValue({
          oldPassword: password,
        });
      }
    });
  }

  completeNewPassword() {
    if (
      !this.completeNewPasswordForm.get('oldPassword').value ||
      !this.completeNewPasswordForm.get('confirmNewPassword').value ||
      !this.completeNewPasswordForm.get('newPassword').value
    ) {
      this.messageHandlerService.generateToastMessage('warn', '', RESET_PASSWORD_FIELDS_MISSING);
      this.completeNewPasswordForm.get('oldPassword').markAsTouched();
      this.completeNewPasswordForm.get('newPassword').markAsTouched();
      this.completeNewPasswordForm.get('confirmNewPassword').markAsTouched();

      return;
    }

    if (
      !this.completeNewPasswordForm.valid ||
      this.completeNewPasswordForm.get('confirmNewPassword').value !== this.completeNewPasswordForm.get('newPassword').value
    ) {
      this.messageHandlerService.generateToastMessage('error', '', RESET_PASSWORDS_NOT_MATCHING);
      this.completeNewPasswordForm.get('oldPassword').markAsTouched();
      this.completeNewPasswordForm.get('newPassword').markAsTouched();
      this.completeNewPasswordForm.get('confirmNewPassword').markAsTouched();

      return;
    }

    this.authService
      .updatePassword(
        this.completeNewPasswordForm.value.newPassword,
        this.completeNewPasswordForm.value.oldPassword,
        this.cognitoUserService.cognitoUser,
      )
      .then((authenticatedUser) => {
        if (authenticatedUser.challengeName === 'SMS_MFA') {
          this.cognitoUserService.cognitoUser = authenticatedUser;
          this.router.navigate([VERIFICATION_PATH]);
        } else {
          let accessToken = authenticatedUser.signInUserSession.accessToken.jwtToken;
          this.authService.currentUserSubject.next(authenticatedUser);
          // Token must be set before calling updateUserRegistrationStatus, since
          // the auth interceptor reads it from storage to build the Authorization
          // header - calling it any earlier sends the request with no access token.
          this.authService.setToken(accessToken);

          this.subscription = this.userService.updateUserRegistrationStatus({
            aws_cognito_id: this.cognitoUserService.cognitoUser.username,
            registrationStatus: REGISTRATION_ACTIVATED_STATUS
          }).subscribe();

          this.router.navigate(['/']);
          this.completeNewPasswordForm.reset();
        }
      })
      .catch((err) => {
        this.messageHandlerService.generateToastMessage('error', '', 'Invalid old password. Please enter the correct old password.');
        throw err;
      });
  }
}
